import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  NgZone,
} from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { FormGroup } from '@angular/forms';
import { IPatientDetailsPayload } from './interfaces/patient.interface';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { PatientInfoService } from '@ispm/user/services/patientInfo.service';
import { get } from 'lodash';
import { Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ispm-patient-details',
  templateUrl: './patient-details-modal.component.html',
  styleUrls: ['./patient-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('PatientDetails')
export class PatientDetailsComponent implements OnInit, OnDestroy, IWidgetItem<IPatientDetailsPayload> {
  widgetUpdateValueCallback: (value) => void;
  public widgetConfigPayload: IPatientDetailsPayload;
  public data: Array<any>[];
  public searchObject: any;
  public restForm: boolean = false;
  public inputConfig: [DynamicFormItem];
  public widgetFormInstance: FormGroup;
  public _additionalSearchValues: any;
  public formData: any = { };
  public patientDetails: any = { };
  public listenToDataChange = true;
  public patientId: string;
  public patientName: string;
  public showDuplicatePatientWarning: boolean;
  public backUrl: string;
  public backUrlParams: any;
  private destroyed$: Subject<any> = new Subject();
  // private initParamReadOnce: boolean = false;

  set widgetConfig(widgetConfig) {
    this.widgetConfigPayload = widgetConfig.widgetPayload;
    this.inputConfig = [
      Object.assign(
        DynamicFormItem.builder(
          this.widgetConfigPayload.searchInput.label || '',
          'patientSearch',
          this.widgetConfigPayload.searchInput.type || ITEMS_TYPES.AUTOCOMPLETE
        ).setCssClass(this.widgetConfigPayload.searchInput.cssClass)
          .setAttributes(this.widgetConfigPayload.searchInput.attributes)
          .setRequired(this.widgetConfigPayload.searchInput.required), this.widgetConfigPayload.searchInput
      )
    ];
    this.backUrl = get(widgetConfig, 'duplicatePatientWarning.backUrl', "");
    this.backUrlParams = get(widgetConfig, 'duplicatePatientWarning.backUrlParams', "");
    this.showDuplicatePatientWarning = get(widgetConfig, 'duplicatePatientWarning.showDuplicatePatient', undefined);
  }

  set widgetData(widgetData: any) {
    if (widgetData) {
      const patient = { patientSearch: widgetData };
      this.formData = Object.assign({ }, patient);
    }
    /* -- The following code reads the widget data from the parent dynamic form. It was commented out becuase it is not needed for now.
    
    else if (this.widgetFormInstance && !this.initParamReadOnce) {
      //Handling opening the component with selected patient (e.g. when creating a test from from search pateint panel or from within the test dahboard)
      if (this.widgetFormInstance.value &&this.widgetFormInstance.value.id  && this.widgetFormInstance.value.text){
        this.initParamReadOnce = true;
        const patient = {
          patientSearch: {
            id: this.widgetFormInstance.value.id,
            text: this.widgetFormInstance.value.text
        }};
        this.formData = Object.assign({}, patient);       
        this.updateSearchObject(patient)
      }
    }
    */
  }

  private _widgetFormInstanceSubmitted: boolean;

  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  };

  constructor(private _zone: NgZone, private _changeDetector: ChangeDetectorRef,
    private _patientInfoService: PatientInfoService,
    private _userActionCreatorService: UserActionCreatorService, ) {
  }

  ngOnInit() { }

  // Pass selected patient details to new test widget
  updateSearchObject(form) {
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [form.patientSearch]);
     //this.widgetUpdateValueCallback(form.patientSearch);
    }
    this.patientId = form.patientSearch.id;
    this.patientName = form.patientSearch.text;
  }

  /**
   * Add new patient functionality  and passing the same details to Test Modal. Can also set additional
   * property in response using paramsToPick property
   * defined inside patient widget config
   */
  addNewPatient() {
    this._userActionCreatorService.getCurrentUser().pipe(takeUntil(this.destroyed$.asObservable()))
      .subscribe(user => {
        this._patientInfoService.openPatientInfo(null, user.organization, user.managingOrganization)
        .pipe(takeUntil(this.destroyed$.asObservable()))
        .subscribe((resp) => {
          if ((resp === 2) || (resp.status === 2)) {
          } else if (resp.data === 1) {
            this.patientDetails = resp.payload.patient;
            if (this.patientDetails) {
              this.widgetConfigPayload.paramsToPick.forEach((element, index) => {
                this.patientDetails[element.key] = get(this.patientDetails, element['pathToField']);
              });
              const patient = { patientSearch: this.patientDetails };
              this.formData = Object.assign({ }, patient);
              this.widgetUpdateValueCallback(this.formData.patientSearch);
              this._changeDetector.markForCheck();
              this._changeDetector.detectChanges();
            }
          }
        });
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }

}
